//展示注册的环境
export const visRegisterWeb = [
  'databrain-pre.woa.com',
  'databrain-pre.intlgame.com',
  'databrain-global.intlgame.com',
  'databrain-global-pre.intlgame.com',
  '43.130.4.182',//预发布地址
  //下面环境用于测试
  'databrain-dev.intlgame.com',
  'databrain-test.intlgame.com',
  'localhost:6502',
]

//验证码格式
export const isValidCode = (code: any) => {
  const reg = /^[0-9]{6}$/;
  return reg.test(code);
};

export const isValidEmail = (email: any) => {
  const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,}$/;
  return reg.test(email);
};

//验证gsv (?:")|(?:')|(?:--)|(/\\*(?:.|[\\n\\r])*?\\*/)
export const isValidGsv = (username: any) => {
  const reg = /"|'|--|\/\*(?:.|[\n\r])*?\*\//;
  return reg.test(username);
};

//验证gsv (?:")|(?:')|(?:--)|(/\\*(?:.|[\\n\\r])*?\\*/)
export const isAllowDomain = (domain: any) => {
  const reg = /^(http|https)?:\/\/(([\w\-.]+\.(intlgame|woa)\.com)|(((10\.\d{1,3}\.\d{1,3}\.\d{1,3})|127\.0\.0\.1|localhost)(:[0-9]+)?))($|\/|\\)/i;
  return reg.test(domain);
};

export function processPermissions(data: any) {
  const permissions = Object.keys(data?.permissions || {}).map(v => v.toLowerCase());
  window.sessionStorage.setItem('permissions', permissions.join(','));
  return permissions;
}

export const isEmptyValue = (value: string | undefined) => {
  /**容错处理 */
  if (typeof value !== 'string') {
    return true;
  }
  /**判断为空 */
  if ((!value) || (value?.trim() == '')) {
    return true;
  } else {
    return false;
  }
};

//错误提示
export const getErrorMessage = (message: string, errcode?: number) => {
  switch (errcode) {
    case 999:
      return 'dbh_login_network_error';
    case 4008:
      return 'dbh_login_account_or_email_not';
    case 4001:
      return 'dbh_login_user_not_or_password_wrong';
    case 4003:
      return 'dbh_login_login_errors_5_times';
    default:
      return typeof message === 'string' ? message : '';
  }
}
